import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
 
import App from './App';
import GlobalStyle from './styles/GlobalStyle';
 
 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <GlobalStyle />
    <Router>
    <App />
</Router>
  
  </React.StrictMode>
);

 
